import { render, staticRenderFns } from "./carouselTempale.vue?vue&type=template&id=63ad2750&scoped=true&"
import script from "./carouselTempale.vue?vue&type=script&lang=js&"
export * from "./carouselTempale.vue?vue&type=script&lang=js&"
import style0 from "./carouselTempale.vue?vue&type=style&index=0&id=63ad2750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ad2750",
  null
  
)

export default component.exports